// 性别
export const sexTypes = [
    { value: 'MALE', text: '男' },
    { value: 'FEMALE', text: '女' },
];
